<template>
  <b-table
    :items="items"
    :fields="fields"
    small
    primary-key="Agência"
    :tbody-transition-props="transProps"
    sort-by.sync="ApprovedFinancingAmount"
    sort-desc.sync
  >
    <template v-slot:cell(#)="row">
      <b-form-checkbox
        v-model="row.detailsShowing"
        @change="
          row.toggleDetails();
          get(row);
        "
      ></b-form-checkbox>
    </template>
    <template #row-details="row">
      <branchProposalsTable
        :proposals="
          proposals.filter((el) => el.bankBranch === row.item.Agência)
        "
        :selectedButton="selectedButton"
      />
    </template>
    <template #head(Amount)="">
      <span>{{ selectedButton }}</span>
    </template>
    <template #cell(Amount)="data">
      {{ data.item.Amount | currency }}
    </template>
    <template #cell(TicketMédio)="data">
      {{ data.item.TicketMédio | currency }}
    </template>
    <template #cell(Txc)="data"> {{ data.item.Txc }} % </template>
  </b-table>
</template>
<script>
import { mapActions } from "vuex";
import branchProposalsTable from "@/components/Tables/branchProposalsTable.vue";
export default {
  name: "",
  components: {
    branchProposalsTable,
  },
  props: {
    selectedButton: {
      type: String,
      default: "",
    },
    proposals: {
      type: Array,
      default: () => [],
    },
    allProposals: {
      type: Array,
      default: () => [],
    },
    selectedBranch: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: [
        { key: "#", sortable: false },
        { key: "Agência", sortable: true },
        { key: "Qnt", sortable: true },
        { key: "Amount", sortable: true },
        { key: "TicketMédio", sortable: true },
        { key: "Txc", sortable: true },
      ],
      transProps: {
        name: "flip-list",
      },
      aprovadoCondicionadoRiskProposals: [],
      evoluídaContractProposals: [],
      selectedBranches: [],
    };
  },
  computed: {
    items() {
      let arr = [];
      this.proposals.forEach((element) => {
        let obj = {};
        obj.Agência = element.bankBranch;
        const filteredByBranch = this.proposals.filter(
          (el) => el.bankBranch === element.bankBranch
        );
        obj.Qnt = filteredByBranch.length;
        const addPropertiesByBranch = filteredByBranch.reduce((acc, n) => {
          if (acc.hasOwnProperty("approvedFinancingAmount"))
            acc["approvedFinancingAmount"] += n["approvedFinancingAmount"];
          else acc["approvedFinancingAmount"] = n["approvedFinancingAmount"];
          if (acc.hasOwnProperty("operationValue"))
            acc["operationValue"] += n["operationValue"];
          else acc["operationValue"] = n["operationValue"];
          if (acc.hasOwnProperty("intendedFinancingValue"))
            acc["intendedFinancingValue"] += n["intendedFinancingValue"];
          else acc["intendedFinancingValue"] = n["intendedFinancingValue"];
          return acc;
        }, {});

        if (this.selectedButton === "Estoque") {
          obj.Amount = addPropertiesByBranch.approvedFinancingAmount;
          obj.TicketMédio = obj.Amount / obj.Qnt;
        } else if (this.selectedButton === "Fluxo") {
          obj.Amount = addPropertiesByBranch.intendedFinancingValue;
          obj.TicketMédio = obj.Amount / obj.Qnt;
        } else if (this.selectedButton === "Resultado") {
          obj.Amount = addPropertiesByBranch.operationValue;
          obj.TicketMédio = obj.Amount / obj.Qnt;
        }
        let RiskProposalsFilterByBank = this.aprovadoCondicionadoRiskProposals.filter(
          (el) => el.bankBranch === element.bankBranch
        );
        let txc = 0;
        if (this.selectedButton === "Estoque") {
          const filterAllProposalsByBank = this.allProposals.filter(
            (el) => el.bankBranch === element.bankBranch
          );
          txc =
            (RiskProposalsFilterByBank.length /
              filterAllProposalsByBank.length) *
            100;
        } else if (this.selectedButton === "Resultado") {
          const filterEvoluídaContractProposalsByBank = this.evoluídaContractProposals.filter(
            (el) => el.bankBranch === element.bankBranch
          );
          txc =
            (filterEvoluídaContractProposalsByBank.length /
              RiskProposalsFilterByBank.length) *
            100;
        }
        obj.Txc =
          typeof txc === "number" && !Number.isInteger(txc)
            ? txc.toFixed(2)
            : txc;
        if (arr.length) {
          if (!arr.some((el) => el.Agência === element.bankBranch)) {
            arr.push(obj);
          }
        } else {
          arr.push(obj);
        }
      });
      return arr;
    },
  },
  watch: {
    async selectedButton() {
      const response = await this.getAprovadoCondicionadoRiskProposals();
      this.aprovadoCondicionadoRiskProposals = response;
      if (this.selectedButton === "Resultado") {
        const response = await this.getEvoluídaContractProposals();
        this.evoluídaContractProposals = response;
      }
    },
    selectedBranch(newVal) {
      this.selectedBranches = newVal;
    },
  },
  methods: {
    ...mapActions([
      "getAprovadoCondicionadoRiskProposals",
      "getEvoluídaContractProposals",
    ]),
    get(row) {
      if (!this.selectedBranches.includes(row.item.Agência)) {
        this.selectedBranches.push(row.item.Agência);
      } else {
        const index = this.selectedBranches.indexOf(row.item.Agência);
        this.selectedBranches.splice(index, 1);
      }
      this.$emit("getSelectedBranches", this.selectedBranches);
    },
  },
};
</script>

<style scoped>
>>> .b-table-details > td {
  padding: 0;
}
</style>
